import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { MapComponent } from './map/map.component';
import { VehiclesComponent } from './vehicles/vehicles.component';
import { TripComponent } from './trip/trip.component';
import { ReportComponent } from './report/report.component';
import { AppRoutingGuard } from './app-routing.guard';
import { SharedMapComponent } from './shared-map/shared-map.component';

const routes: Routes = [
	{ path: '', component: LoginComponent },
	{ path: 'map', component: MapComponent, canActivate: [AppRoutingGuard] },
	{ path: 'fleet', component: VehiclesComponent, canActivate: [AppRoutingGuard] },
	{ path: 'trip', component: TripComponent, canActivate: [AppRoutingGuard] },
	{ path: 'report', component: ReportComponent, canActivate: [AppRoutingGuard] },
	{ path: 'public-vehicle/:user/:hash/:datetm', component: SharedMapComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
